import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import { GET_ORGANIZATION, GET_ORGANIZATIONS } from "./queries";
import {
  GetOrganizations,
  GetOrganizationsVariables,
} from "./__generated__/GetOrganizations";
import {
  CREATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  UPDATE_ORGANIZATION,
} from "./mutations";
import {
  CreateOrganization,
  CreateOrganizationVariables,
} from "./__generated__/CreateOrganization";
import {
  GetOrganization,
  GetOrganizationVariables,
} from "./__generated__/GetOrganization";
import {
  UpdateOrganization,
  UpdateOrganizationVariables,
} from "./__generated__/UpdateOrganization";
import {
  DeleteOrganization,
  DeleteOrganizationVariables,
} from "./__generated__/DeleteOrganization";

export const useOrganizationListQuery = makeQueryHook<
  GetOrganizations,
  GetOrganizationsVariables
>(GET_ORGANIZATIONS);

export const useOrganizationDetailsQuery = makeQueryHook<
  GetOrganization,
  GetOrganizationVariables
>(GET_ORGANIZATION);

export const useOrganizationCreate = makeMutationHook<
  CreateOrganization,
  CreateOrganizationVariables
>(CREATE_ORGANIZATION);

export const useOrganizationUpdateMutation = makeMutationHook<
  UpdateOrganization,
  UpdateOrganizationVariables
>(UPDATE_ORGANIZATION);

export const useOrganizationDeleteMutation = makeMutationHook<
  DeleteOrganization,
  DeleteOrganizationVariables
>(DELETE_ORGANIZATION);
